/** @file dock-manager/formatters.js — date/time helpers, rendered in the active site's timezone. */

let DISPLAY_TZ;

/** Dock Manager sets this to the selected site's timezone before rendering the grid. */
export function setDisplayTz(tz) {
  DISPLAY_TZ = tz || undefined;
}

const fmt = (d, opts) => new Date(d).toLocaleString("en-AU", { timeZone: DISPLAY_TZ, hour12: false, ...opts });

const hm = (d) => {
  const p = new Intl.DateTimeFormat("en-GB", { timeZone: DISPLAY_TZ, hour: "2-digit", minute: "2-digit", hour12: false })
    .formatToParts(new Date(d)).reduce((m, x) => ((m[x.type] = x.value), m), {});
  return { hour: p.hour === "24" ? "00" : p.hour, minute: p.minute };
};

export function fmtClock(d) {
  const { hour, minute } = hm(d);
  return `${hour}:${minute}`;
}
export function fmtHour(d) {
  return `${hm(d).hour}:00`;
}
export function isSiteMidnight(d) {
  return hm(d).hour === "00";
}
export function fmtDayLabel(d) {
  return fmt(d, { weekday: "short", day: "2-digit", month: "short", hour: undefined, minute: undefined });
}
export function fmtFull(iso) {
  return fmt(iso, { weekday: "short", day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
}
export function fmtRange(s, e) {
  return `${fmtFull(s)}  →  ${fmtFull(e)}`;
}
